module.exports = __webpack_public_path__ + "img/appAsset-brand--stripeLogo.30b4602c.svg";